import {
  getLeoUuid,
  LeoUUID,
  getString,
  getLeoTimestamp,
  LeoTimestamp,
} from "@surya-digital/leo-ts-types";

export interface GetAllArchivedProjectsPaginationResponseDTO {
  projectId: string;
  projectName: string;
  creator: string;
  surveys: string;
  createdOn: string;
  lastModified: string;
}

export class GetAllArchivedProjectsPaginationResponse {
  readonly isGetAllArchivedProjectsPaginationResponseGetAllArchivedProjectsPaginationResponse: boolean = true;

  readonly projectId: LeoUUID;
  readonly projectName: string;
  readonly creator: string;
  readonly surveys: string;
  readonly createdOn: LeoTimestamp;
  readonly lastModified: LeoTimestamp;


  constructor(
  projectId: LeoUUID, 
  projectName: string, 
  creator: string, 
  surveys: string, 
  createdOn: LeoTimestamp, 
  lastModified: LeoTimestamp
  ) {
    this.projectId = projectId;
    GetAllArchivedProjectsPaginationResponse.validateProjectName(projectName);
    this.projectName = projectName;
    GetAllArchivedProjectsPaginationResponse.validateCreator(creator);
    this.creator = creator;
    GetAllArchivedProjectsPaginationResponse.validateSurveys(surveys);
    this.surveys = surveys;
    this.createdOn = createdOn;
    this.lastModified = lastModified;
  }

  static fromDTO(dto: GetAllArchivedProjectsPaginationResponseDTO): GetAllArchivedProjectsPaginationResponse {
    const projectId = getLeoUuid(dto, "projectId", InvalidGetAllArchivedProjectsPaginationResponseProjectIdError);
    const projectName = getString(dto, "projectName", InvalidGetAllArchivedProjectsPaginationResponseProjectNameError);
    const creator = getString(dto, "creator", InvalidGetAllArchivedProjectsPaginationResponseCreatorError);
    const surveys = getString(dto, "surveys", InvalidGetAllArchivedProjectsPaginationResponseSurveysError);
    const createdOn = getLeoTimestamp(dto, "createdOn", InvalidGetAllArchivedProjectsPaginationResponseCreatedOnError);
    const lastModified = getLeoTimestamp(dto, "lastModified", InvalidGetAllArchivedProjectsPaginationResponseLastModifiedError);
    return new GetAllArchivedProjectsPaginationResponse(
      projectId,
      projectName,
      creator,
      surveys,
      createdOn,
      lastModified
    );
  }

  toDTO(): GetAllArchivedProjectsPaginationResponseDTO {
    const dto: GetAllArchivedProjectsPaginationResponseDTO = {
        projectId: this.projectId.toDTO(),
        projectName: this.projectName,
        creator: this.creator,
        surveys: this.surveys,
        createdOn: this.createdOn.toDTO(),
        lastModified: this.lastModified.toDTO()
    };
    return dto;
  }
  private static validateProjectName = (projectName: string): void => {
    if(projectName.trim().length === 0) {
      throw new InvalidGetAllArchivedProjectsPaginationResponseProjectNameNonEmptyError(
        `Attribute projectName cannot be an empty string.`
      );
    }
  }
  private static validateCreator = (creator: string): void => {
    if(creator.trim().length === 0) {
      throw new InvalidGetAllArchivedProjectsPaginationResponseCreatorNonEmptyError(
        `Attribute creator cannot be an empty string.`
      );
    }
  }
  private static validateSurveys = (surveys: string): void => {
    if(surveys.trim().length === 0) {
      throw new InvalidGetAllArchivedProjectsPaginationResponseSurveysNonEmptyError(
        `Attribute surveys cannot be an empty string.`
      );
    }
  }
  
}

GetAllArchivedProjectsPaginationResponse.prototype.toString = function toString(): string {
  return `GetAllArchivedProjectsPaginationResponse(projectId='${this.projectId}',projectName='${this.projectName}',creator='${this.creator}',surveys='${this.surveys}',createdOn='${this.createdOn}',lastModified='${this.lastModified}')`;
};

export class InvalidGetAllArchivedProjectsPaginationResponseError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllArchivedProjectsPaginationResponseError";
  }
}
export class InvalidGetAllArchivedProjectsPaginationResponseProjectIdError extends InvalidGetAllArchivedProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllArchivedProjectsPaginationResponseProjectIdError";
  }
}

export class InvalidGetAllArchivedProjectsPaginationResponseProjectNameError extends InvalidGetAllArchivedProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllArchivedProjectsPaginationResponseProjectNameError";
  }
}

export class InvalidGetAllArchivedProjectsPaginationResponseProjectNameNonEmptyError extends InvalidGetAllArchivedProjectsPaginationResponseProjectNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllArchivedProjectsPaginationResponseProjectNameNonEmptyError";
  }
}

export class InvalidGetAllArchivedProjectsPaginationResponseCreatorError extends InvalidGetAllArchivedProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllArchivedProjectsPaginationResponseCreatorError";
  }
}

export class InvalidGetAllArchivedProjectsPaginationResponseCreatorNonEmptyError extends InvalidGetAllArchivedProjectsPaginationResponseCreatorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllArchivedProjectsPaginationResponseCreatorNonEmptyError";
  }
}

export class InvalidGetAllArchivedProjectsPaginationResponseSurveysError extends InvalidGetAllArchivedProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllArchivedProjectsPaginationResponseSurveysError";
  }
}

export class InvalidGetAllArchivedProjectsPaginationResponseSurveysNonEmptyError extends InvalidGetAllArchivedProjectsPaginationResponseSurveysError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllArchivedProjectsPaginationResponseSurveysNonEmptyError";
  }
}

export class InvalidGetAllArchivedProjectsPaginationResponseCreatedOnError extends InvalidGetAllArchivedProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllArchivedProjectsPaginationResponseCreatedOnError";
  }
}

export class InvalidGetAllArchivedProjectsPaginationResponseLastModifiedError extends InvalidGetAllArchivedProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllArchivedProjectsPaginationResponseLastModifiedError";
  }
}
